import { Check } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/hooks/useSEO";
import { ICONS } from "@/lib/icons";
import { PROCESS_STEPS, PROCESS_HIGHLIGHTS } from "@/lib/site";

export default function Proses() {
  useSEO(
    "Proses Kerja",
    "Proses produksi berbasis sistem HATTORY KONVEKSI: konsultasi, desain, DP, produksi, quality control berlapis, hingga pengiriman ke seluruh Indonesia."
  );

  return (
    <>
      <PageHero
        overline="Proses Kerja"
        titleLines={["Proses Produksi", "Berbasis Sistem"]}
        description="Kami menerapkan proses produksi yang terstruktur agar setiap pesanan diproduksi secara konsisten, tepat waktu, dan sesuai standar kualitas HATTORY."
      />

      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
          {/* Sticky highlight bar */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <Reveal>
                <h2 className="text-2xl font-black tracking-tight text-navy">Standar HATTORY</h2>
                <p className="mt-3 text-sm text-charcoal/70">Setiap langkah dijalankan dengan disiplin dan pemeriksaan bertahap.</p>
                <ul className="mt-8 space-y-4" data-testid="process-highlights">
                  {PROCESS_HIGHLIGHTS.map((h) => (
                    <li key={h} className="flex items-center gap-3">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-navy text-white">
                        <Check className="h-4 w-4" />
                      </span>
                      <span className="font-medium text-navy">{h}</span>
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>
          </div>

          {/* Steps */}
          <div className="lg:col-span-8">
            <div className="space-y-5" data-testid="process-steps">
              {PROCESS_STEPS.map((s, i) => {
                const Icon = ICONS[s.icon];
                return (
                  <Reveal key={s.n} delay={i * 0.05}>
                    <div className="group flex gap-6 rounded-3xl border border-silver/30 p-7 transition-colors hover:border-navy md:p-8">
                      <div className="flex flex-col items-center">
                        <span className="text-4xl font-black text-silver/50 md:text-5xl">{s.n}</span>
                        <span className="mt-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-surface text-navy transition-colors group-hover:bg-navy group-hover:text-white">
                          {Icon && <Icon className="h-5 w-5" />}
                        </span>
                      </div>
                      <div className="pt-1">
                        <h3 className="text-2xl font-bold tracking-tight text-navy">{s.title}</h3>
                        <p className="mt-2 leading-relaxed text-charcoal/80">{s.desc}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <CTABand
        title="Siap Memulai Pesanan Anda?"
        buttonLabel="Mulai Konsultasi"
        waMsg="Halo HATTORY KONVEKSI, saya sudah paham prosesnya dan ingin memulai konsultasi order."
      />
    </>
  );
}
